<template>
  <div>
    <div
      class="modal fade"
      id="modal-form-seguimiento-novedades"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <!-- Header -->
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <div class="col-md-6">
              <h4 class="modal-title text-white">
                {{ title }}
              </h4>
            </div>

            <div class="col-md-2 text-right">
              <button
                type="button"
                class="close text-white"
                data-dismiss="modal"
              >
                <span>&times;</span>
              </button>
            </div>
          </div>

          <!-- Body -->
          <div class="modal-body">
            <div class="card-body p-0" v-if="novedad">
              <div class="row">
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="vehiculo">Vehiculo</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="vehiculo"
                      placeholder="Vehiculo"
                      :value="novedad?.entidad?.vehiculo?.placa"
                      readonly
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="conductor">Conductor</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="conductor"
                      placeholder="Conductor"
                      :value="
                        novedad?.entidad?.conductor?.nombres +
                          ' ' +
                          novedad?.entidad?.conductor?.apellidos
                      "
                      readonly
                    />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="fecha_reporte">Fecha Reporte</label>
                    <input
                      type="date"
                      class="form-control form-control-sm has-success"
                      id="fecha_reporte"
                      placeholder="Fecha Reporte"
                      :value="fecha_Actual"
                      :class="{
                        'is-valid': fecha_Actual,
                        'is-invalid': !fecha_Actual,
                      }"
                    />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="hora_reporte">Hora Reporte</label>
                    <input
                      type="time"
                      class="form-control form-control-sm"
                      id="hora_reporte"
                      placeholder="Hora Reporte"
                      :value="hora_Actual"
                      :class="{
                        'is-valid': hora_Actual,
                        'is-invalid': !hora_Actual,
                      }"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="direccion">Dirección</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="direccion"
                      placeholder="Dirección"
                      :value="novedad.direccion"
                      :class="{
                        'is-valid': novedad.direccion,
                        'is-invalid': !novedad.direccion,
                      }"
                    />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="latitud">Latitud</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="latitud"
                      placeholder="Latitud"
                      :value="coordenadas.lat"
                      readonly
                    />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="longitud">Longitud</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="longitud"
                      placeholder="Longitud"
                      :value="coordenadas.lng"
                      readonly
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="novedad">Novedad</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="novedad"
                      placeholder="Novedad"
                      :value="novedad.nSubNovedadGps"
                      :class="{
                        'is-valid': novedad.nSubNovedadGps,
                        'is-invalid': !novedad.nSubNovedadGps,
                      }"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="card-body p-0" v-if="tep">
              <div class="row">
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="vehiculo">Vehiculo</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="vehiculo"
                      placeholder="Vehiculo"
                      :value="tep.vehiculo?.placa"
                      readonly
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="conductor">Conductor</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="conductor"
                      placeholder="Conductor"
                      :value="
                        tep.conductor?.nombres + ' ' + tep.conductor?.apellidos
                      "
                      readonly
                    />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="fecha_reporte">Fecha Reporte</label>
                    <input
                      type="date"
                      class="form-control form-control-sm has-success"
                      id="fecha_reporte"
                      placeholder="Fecha Reporte"
                      :class="{
                        'is-valid': fecha_Actual,
                        'is-invalid': !fecha_Actual,
                      }"
                    />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="hora_reporte">Hora Reporte</label>
                    <input
                      type="time"
                      class="form-control form-control-sm"
                      id="hora_reporte"
                      placeholder="Hora Reporte"
                      :value="hora_Actual"
                      :class="{
                        'is-valid': hora_Actual,
                        'is-invalid': !hora_Actual,
                      }"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="direccion">Dirección</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="direccion"
                      placeholder="Dirección"
                      :value="tep.vehiculo?.gpss[0]?.strDireccion"
                    />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="latitud">Latitud</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="latitud"
                      placeholder="Latitud"
                      :value="coordenadas.lat"
                      readonly
                    />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="longitud">Longitud</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="longitud"
                      placeholder="Longitud"
                      :value="coordenadas.lng"
                      readonly
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="card-body p-0" v-if="tif">
              <div class="row">
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="vehiculo">Vehiculo</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="vehiculo"
                      placeholder="Vehiculo"
                      :value="tif?.vehiculo?.placa"
                      readonly
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="conductor">Conductor</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="conductor"
                      placeholder="Conductor"
                      :value="
                        tif?.conductor?.nombres +
                          ' ' +
                          tif?.conductor?.apellidos
                      "
                      readonly
                    />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="fecha_reporte">Fecha Reporte</label>
                    <input
                      type="date"
                      class="form-control form-control-sm has-success"
                      id="fecha_reporte"
                      placeholder="Fecha Reporte"
                      :value="fecha_Actual"
                      :class="{
                        'is-valid': fecha_Actual,
                        'is-invalid': !fecha_Actual,
                      }"
                    />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="hora_reporte">Hora Reporte</label>
                    <input
                      type="time"
                      class="form-control form-control-sm"
                      id="hora_reporte"
                      placeholder="Hora Reporte"
                      :value="hora_Actual"
                      :class="{
                        'is-valid': hora_Actual,
                        'is-invalid': !hora_Actual,
                      }"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="direccion">Dirección</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="direccion"
                      placeholder="Dirección"
                      :value="tif.vehiculo?.gpss[0]?.strDireccion"
                      :class="{
                        'is-valid': tif.vehiculo?.gpss[0]?.strDireccion,
                        'is-invalid': !tif.vehiculo?.gpss[0]?.strDireccion,
                      }"
                    />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="latitud">Latitud</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="latitud"
                      placeholder="Latitud"
                      :value="coordenadas.lat"
                      readonly
                    />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="longitud">Longitud</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="longitud"
                      placeholder="Longitud"
                      :value="coordenadas.lng"
                      readonly
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="card-body p-0" v-if="plant">
              <div class="row">
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="vehiculo">Vehiculo</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="vehiculo"
                      placeholder="Vehiculo"
                      :value="plant?.vehiculo?.placa"
                      readonly
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="conductor">Conductor</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="conductor"
                      placeholder="Conductor"
                      :value="
                        plant?.conductor?.nombres +
                          ' ' +
                          plant?.conductor?.apellidos
                      "
                      readonly
                    />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="fecha_reporte">Fecha Reporte</label>
                    <input
                      type="date"
                      class="form-control form-control-sm has-success"
                      id="fecha_reporte"
                      placeholder="Fecha Reporte"
                      :value="fecha_Actual"
                      :class="{
                        'is-valid': fecha_Actual,
                        'is-invalid': !fecha_Actual,
                      }"
                    />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="hora_reporte">Hora Reporte</label>
                    <input
                      type="time"
                      class="form-control form-control-sm"
                      id="hora_reporte"
                      placeholder="Hora Reporte"
                      :value="hora_Actual"
                      :class="{
                        'is-valid': hora_Actual,
                        'is-invalid': !hora_Actual,
                      }"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="direccion">Dirección</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="direccion"
                      placeholder="Dirección"
                      :value="plant.vehiculo?.gpss[0]?.strDireccion"
                      :class="{
                        'is-valid': plant.vehiculo?.gpss[0]?.strDireccion,
                        'is-invalid': !plant.vehiculo?.gpss[0]?.strDireccion,
                      }"
                    />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="latitud">Latitud</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="latitud"
                      placeholder="Latitud"
                      :value="coordenadas.lat"
                      readonly
                    />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="longitud">Longitud</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="longitud"
                      placeholder="Longitud"
                      :value="coordenadas.lng"
                      readonly
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="card-body p-0">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="observacion">Observacion</label>
                  <textarea
                    class="form-control form-control-sm"
                    v-model="form.observacion"
                    :class="{
                      'is-valid': form.observacion,
                      'is-invalid': !form.observacion,
                    }"
                  ></textarea>
                </div>
              </div>
            </div>

            <!-- Seccion mapa -->
            <div class="row g-2 pt-2">
              <div class="col-12 col-lg-6">
                <div class="card shadow-sm h-100" v-if="!cargando">
                  <div class="card-body p-0 position-relative">
                    <div v-if="cargandoMapa" class="text-center p-4">
                      <i class="fas fa-spinner fa-spin fa-2x"></i>
                      <p>Cargando mapa...</p>
                    </div>

                    <gmap-map
                      v-if="!cargandoMapa && (novedad || tep || tif || plant)"
                      class="w-100"
                      style="height: 500px"
                      :center="mapCenter"
                      :zoom="mapZoom"
                      :options="mapOptions"
                    >
                      <gmap-marker
                        v-for="(marker, index) in markers"
                        :key="index"
                        :position="marker.position"
                        :draggable="true"
                        @dragend="onMarkerDrag($event, index)"
                        @click="toggleInfoWindow(marker)"
                      />

                      <gmap-info-window
                        :position="infoWindowPosition"
                        :opened="infoWindowOpen"
                        @closeclick="infoWindowOpen = false"
                      >
                        <div v-html="infoWindowContent"></div>
                      </gmap-info-window>
                    </gmap-map>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-6">
                <div class="card shadow-sm h-100">
                  <div v-if="cargando" class="text-center p-3">
                    <div class="mb-2">
                      <i class="fas fa-spinner fa-spin fa-2x text-primary"></i>
                    </div>
                    <h6 class="text-muted mb-1" style="font-size: 0.85rem;">
                      Cargando reportes...
                    </h6>
                    <small class="text-muted" style="font-size: 0.7rem;">
                      Buscando información reportes GPS
                    </small>
                  </div>
                  <div class="table-responsive" v-else>
                    <table
                      class="table table-striped  mb-0 text-nowrap table-bordered"
                    >
                      <thead class="table-dark">
                        <tr>
                          <th>Fecha</th>
                          <th>Placa</th>
                          <th>Velocidad</th>
                          <th>Dirección</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in registros_Gps"
                          :key="index"
                          class="align-middle"
                        >
                          <td class="text-center">
                            {{ item.dteFechaReporte }}
                          </td>
                          <td>
                            {{ item.strPlaca }}
                          </td>
                          <td>{{ item.intVelocidadInstantanea }} Km/h</td>
                          <td class="d-flex align-items-center">
                            {{ item.strDireccion }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Footer -->
          <div class="modal-footer justify-content-center">
            <button
              class="btn btn-primary"
              v-if="$store.getters.can('tif.centralTrafico.crearSeguimiento')"
              :disabled="!form.observacion"
              @click="guardarSeguimiento()"
            >
              <i class="fas fa-save me-1"></i> Guardar seguimiento
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
const $ = window.$;

export default {
  name: "SeguimientoNovedades",

  data() {
    return {
      novedad: null,
      coordenadas: null,
      tep: null,
      tif: null,
      plant: null,
      title: null,
      info_map: null,
      accion_map: null,
      registros_Gps: null,
      cargandoMapa: true,
      cargando: true,
      fecha_Actual: null,
      hora_Actual: null,
      mapCenter: { lat: 4.6097, lng: -74.0817 },
      mapZoom: 12,
      form: { observacion: null },
      mapOptions: {
        styles: [
          {
            featureType: "poi",
            elementType: "labels",
            stylers: [{ visibility: "off" }],
          },
        ],
      },

      markers: [],

      infoWindowOpen: false,
      infoWindowPosition: null,
      infoWindowContent: "",
    };
  },

  methods: {
    limpiarModal() {
      this.novedad = null;
      this.plant = null;
      this.tep = null;
      this.tif = null;
      this.coordenadas = {
        lat: 4.6097,
        lng: -74.0817,
      };
      this.registros_Gps = null;
      this.form.observacion = null;
      this.info_map = null;
      this.accion_map = null;
      this.title = null;
    },

    init(accion, item, gps) {
      this.limpiarModal();

      switch (accion) {
        case "novedades":
          this.novedad = item;
          this.coordenadas = {
            lat: item.latitud,
            lng: item.longitud,
          };
          this.registros_Gps = gps;
          this.info_map = item;
          this.accion_map = accion;
          this.title = "Seguimiento novedad";

          break;

        case "tep":
          this.tep = item;
          this.coordenadas = {
            lat: item.vehiculo?.gpss[0]?.dblLatitud
              ? item.vehiculo?.gpss[0]?.dblLatitud
              : 4.6097,
            lng: item.vehiculo?.gpss[0]?.dblLongitud
              ? item.vehiculo?.gpss[0]?.dblLongitud
              : -74.0817,
          };
          this.registros_Gps = gps;
          this.info_map = item;
          this.accion_map = accion;
          this.title = "Seguimiento TEP";
          break;

        case "tif":
          this.tif = item;
          this.coordenadas = {
            lat: item.vehiculo?.gpss[0]?.dblLatitud
              ? item.vehiculo?.gpss[0]?.dblLatitud
              : 4.6097,
            lng: item.vehiculo?.gpss[0]?.dblLongitud
              ? item.vehiculo?.gpss[0]?.dblLongitud
              : -74.0817,
          };
          this.registros_Gps = gps;
          this.info_map = item;
          this.accion_map = accion;
          this.title = "Seguimiento TIF";
          break;

        case "plant":
          this.plant = item;
          this.coordenadas = {
            lat: item.vehiculo?.gpss[0]?.dblLatitud
              ? item.vehiculo?.gpss[0]?.dblLatitud
              : 4.6097,
            lng: item.vehiculo?.gpss[0]?.dblLongitud
              ? item.vehiculo?.gpss[0]?.dblLongitud
              : -74.0817,
          };
          this.registros_Gps = gps;
          this.info_map = item;
          this.accion_map = accion;
          this.title = "Seguimiento Planta Externa";
          break;
        default:
          this.coordenadas = {
            lat: 4.6097,
            lng: -74.0817,
          };
          break;
      }

      this.cargandoMapa = true;
      this.cargando = true;
      this.fecha_Actual = moment().format("YYYY-MM-DD");
      this.hora_Actual = moment().format("HH:mm");

      this.$nextTick(() => {
        this.cargarMapa();
      });
    },

    guardarSeguimiento() {
      this.cargando = true;

      let payload = {};
      let type = null;

      switch (this.accion_map) {
        case "novedades":
          payload = {
            novedad_id: this.novedad.id,
            viaje_id: this.novedad.entidad_id,
            novedad_type: "App\\NovedadVehiculo",
            viaje_type: this.novedad.entidad_type,
            fecha_reporte: this.fecha_Actual,
            hora_reporte: this.hora_Actual,
            direccion: this.novedad.direccion,
            observacion: this.form.observacion,
            latitud: this.coordenadas.lat,
            longitud: this.coordenadas.lng,
            estado: this.novedad.estado,
            accion: this.accion_map,
          };
          break;

        case "tep":
          if (this.tep.tipo == "Turno") {
            type = "App\\TepTurno";
          } else {
            type = "App\\TepViajes";
          }

          payload = {
            novedad_id: null,
            viaje_id: this.tep.id,
            novedad_type: "",
            viaje_type: type,
            fecha_reporte: this.fecha_Actual,
            hora_reporte: this.hora_Actual,
            direccion: this.tep.vehiculo?.gpss[0]?.strDireccion,
            observacion: this.form.observacion,
            latitud: this.coordenadas.lat,
            longitud: this.coordenadas.lng,
            estado: this.tep.estado,
            accion: this.accion_map,
          };
          break;

        case "tif":
          payload = {
            novedad_id: null,
            viaje_id: this.tif.id,
            novedad_type: "",
            viaje_type: "App\\TifTurnos",
            fecha_reporte: this.fecha_Actual,
            hora_reporte: this.hora_Actual,
            direccion: this.tif.vehiculo?.gpss[0]?.strDireccion,
            observacion: this.form.observacion,
            latitud: this.coordenadas.lat,
            longitud: this.coordenadas.lng,
            estado: this.tif.estado,
            accion: this.accion_map,
          };
          break;

        case "plant":
          payload = {
            novedad_id: null,
            viaje_id: this.plant.id,
            novedad_type: "",
            viaje_type: "App\\PlantViaje",
            fecha_reporte: this.fecha_Actual,
            hora_reporte: this.hora_Actual,
            direccion: this.plant.vehiculo?.gpss[0]?.strDireccion,
            observacion: this.form.observacion,
            latitud: this.coordenadas.lat,
            longitud: this.coordenadas.lng,
            estado: this.plant.estado,
            accion: this.accion_map,
          };
          break;

        default:
          payload = {};
          break;
      }

      axios
        .post("/api/tif/centralTrafico/crearSeguimiento", payload)
        .then((response) => {
          this.$swal({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            icon: "success",
            title: "Guardado",
            text: response.data.message,
          });

          $("#modal-form-seguimiento-novedades").modal("hide");
          this.form.observacion = null;
        })
        .catch((error) => {
          let mensaje = "Error al guardar el seguimiento";

          if (error.response?.data?.errors) {
            mensaje = Object.values(error.response.data.errors)
              .flat()
              .join("\n");
          } else if (error.response?.data?.message) {
            mensaje = error.response.data.message;
          }

          this.$swal({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            icon: "error",
            title: "Error",
            text: mensaje,
          });
        })
        .finally(() => {
          this.cargando = false;
        });
    },

    onMarkerDrag(event, index) {
      const lat = event.latLng.lat();
      const lng = event.latLng.lng();

      // Actualiza marcador
      this.markers[index].position = { lat, lng };

      // Actualiza latitud y longitud
      this.coordenadas.lat = lat;
      this.coordenadas.lng = lng;
    },

    cargarMapa() {
      if (!this.coordenadas) return;

      if (this.coordenadas.lat && this.coordenadas.lng) {
        const lat = parseFloat(this.coordenadas.lat);
        const lng = parseFloat(this.coordenadas.lng);

        this.mapCenter = { lat, lng };
        this.mapZoom = 15;

        this.markers = [
          {
            position: { lat, lng },
            icon: this.getMarkerIcon(),
            info: this.info_map,
          },
        ];
      }

      this.cargandoMapa = false;
      this.cargando = false;
    },

    getMarkerIcon() {
      const colores = {
        1: "#ffc107",
        2: "#dc3545",
        3: "#17a2b8",
      };

      return {
        path:
          "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z",
        fillColor: "#6c757d",
        fillOpacity: 1,
        strokeColor: "#ffffff",
        strokeWeight: 2,
        scale: 1.5,
      };
    },

    toggleInfoWindow(marker) {
      this.infoWindowPosition = marker.position;
      this.infoWindowContent = this.getInfoContent(
        marker.info,
        this.accion_map,
      );
      this.infoWindowOpen = true;
    },

    getInfoContent(info, accion) {
      let conductor = null,
        placa = null,
        velocidad = null,
        direccion = null;

      switch (accion) {
        case "novedades":
          conductor =
            (info?.entidad?.conductor?.nombres || "") +
            " " +
            (info?.entidad?.conductor?.apellidos || "");
          placa = info?.entidad?.vehiculo?.placa || "N/A";
          velocidad = info.velocidad != null ? info.velocidad + " km/h" : "N/A";
          direccion = info.direccion || "N/A";
          break;

        case "tep":
          conductor =
            (info.conductor?.nombres || "") +
            " " +
            (info.conductor?.apellidos || "");
          placa = info.vehiculo?.placa || "N/A";
          velocidad =
            info.vehiculo?.gpss[0]?.intVelocidadInstantanea != null
              ? info.vehiculo?.gpss[0]?.intVelocidadInstantanea + " km/h"
              : "N/A";
          direccion = info.vehiculo?.gpss[0]?.strDireccion || "N/A";
          break;

        case "tif":
          conductor =
            (info.conductor?.nombres || "") +
            " " +
            (info.conductor?.apellidos || "");
          placa = info.vehiculo?.placa || "N/A";
          velocidad =
            info.vehiculo?.gpss[0]?.intVelocidadInstantanea != null
              ? info.vehiculo?.gpss[0]?.intVelocidadInstantanea + " km/h"
              : "N/A";
          direccion = info.vehiculo?.gpss[0]?.strDireccion || "N/A";
          break;

        case "plant":
          conductor =
            (info.conductor?.nombres || "") +
            " " +
            (info.conductor?.apellidos || "");
          placa = info.vehiculo?.placa || "N/A";
          velocidad =
            info.vehiculo?.gpss[0]?.intVelocidadInstantanea != null
              ? info.vehiculo?.gpss[0]?.intVelocidadInstantanea + " km/h"
              : "N/A";
          direccion = info.vehiculo?.gpss[0]?.strDireccion || "N/A";
          break;

        default:
          conductor = null;
          placa = null;
          velocidad = null;
          direccion = null;
          break;
      }

      return `
        <div style="min-width:220px; font-size:12px;">
          <div style="font-weight:bold; margin-bottom:4px;">
            👤 ${conductor || "N/A"}
          </div>

          <div>🚛 <strong>Placa:</strong> ${placa}</div>
          <div>📍 <strong>Dirección:</strong> ${direccion}</div>
          <div>⚡ <strong>Velocidad:</strong> ${velocidad}</div>

          <hr style="margin:6px 0"/>
        </div>
      `;
    },
  },
};
</script>
